import { Typography, TypographyProps } from "@mui/material";

export const CarDisclosure = (props: TypographyProps) => (
  <Typography {...props} variant="mediumItalic" />
);
